import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ createdAt, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTime = () => {
      const created = new Date(createdAt).getTime();
      const deadline = created + (24 * 60 * 60 * 1000); // 24 hours in ms
      const now = new Date().getTime();
      const difference = deadline - now;

      if (difference <= 0) {
        setTimeLeft("Expired");
        setIsExpired(true);
        onExpire(); // Notify parent to disable button
        return;
      }

      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    };

    const timer = setInterval(calculateTime, 1000);
    calculateTime(); // Initial call

    return () => clearInterval(timer);
  }, [createdAt, onExpire]);

  return <span style={{ color: isExpired ? 'red' : 'inherit' }}>{timeLeft}</span>;
};
export default CountdownTimer;